// catch 절의 errorResponse는 any 또는 unknown 형식만 허용함
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { AxiosResponse } from 'axios';

import { PropsType as ToastPropsType } from '../designSystem/components/Toast/Toast';
import createToast from '../designSystem/components/Toast/createToast';

import { CODE_LIST_FOR_USING_SERVER_ERROR_MESSAGE } from '../constants/api';
import { detectMobile } from '@myrealtrip/device-detect';

import { MrtAxiosException } from '../api/mrtAxiosException';
import { MrtErrorType } from '../api/types';

import error from '../../constants/error';

interface ToastOptionsType extends ToastPropsType {
  show?: boolean;
}

/**
 * @export
 * @template T
 * @param {() => Promise<AxiosResponse<T>>} api
 * @param {ToastOptionsType} [toastOptions]
 * @returns {response, data, error}
 * @example
 */

const getErrorMessage = (errorResponse: MrtAxiosException): string => {
  const commonErrorCode = 'common.error.serverError';

  if (CODE_LIST_FOR_USING_SERVER_ERROR_MESSAGE.includes(errorResponse.code)) {
    return (
      errorResponse.message ||
      error[errorResponse.code as keyof typeof error] ||
      error[commonErrorCode]
    );
  }

  if (errorResponse.isMrtError) {
    return error[errorResponse.code as keyof typeof error] || error[commonErrorCode];
  }

  return error[commonErrorCode];
};

export default async function mrtApiCall<T>(
  api: () => Promise<AxiosResponse<T>>,
  toastOptions?: ToastOptionsType,
) {
  const defaultToastOptions = {
    show: true,
    color: 'warning',
    position: detectMobile() ? 'bottom' : 'top',
  };

  const targetToastOptions = Object.assign(defaultToastOptions, toastOptions || {});

  try {
    const response = await api();

    return { response, data: response.data, error: null };
  } catch (errorResponse: any) {
    const message = getErrorMessage(errorResponse);

    if (targetToastOptions.show) {
      createToast(message, targetToastOptions);
    }

    return {
      response: null,
      data: null,
      error: errorResponse as MrtErrorType<T>,
    };
  }
}
